import { render } from "./TextareaInput.vue?vue&type=template&id=493c6278&ts=true"
import script from "./TextareaInput.vue?vue&type=script&lang=ts"
export * from "./TextareaInput.vue?vue&type=script&lang=ts"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__